module.exports = __webpack_public_path__ + "assets/touxiang.507f704c7efe032b8a86497ac9099d53.png";